import { CardProductId, CreditCard } from '__generated__/GQL';

export const getCardKey = ({
  cardProductId,
  isPhysical,
}: Pick<CreditCard, 'isPhysical' | 'cardProductId'>):
  | 'physical'
  | 'virtual'
  | 'budget' => {
  if (isPhysical) {
    return 'physical';
  }

  if (cardProductId === CardProductId.Budget) {
    return 'budget';
  }

  return 'virtual';
};
